export default __webpack_public_path__ + "static/media/kitchen6.2f4b9518.webp";